// import React, { useState, useEffect } from "react";
// import Layout from "../components/Layout";
// import { Link } from "react-router-dom";



// const Substations = () => {

//     const [substations, setSubstations] = useState([]);

//     useEffect(() => {
//         async function fetchData() {
//             try {
//                 // Запрос всех подстанций
//                 const substationsResponse = await fetch('/api/substation');
//                 if (!substationsResponse.ok) {
//                     throw new Error(`Ошибка при получении подстанций: ${substationsResponse.status}`);
//                 }
//                 const substationsData = await substationsResponse.json();

//                 // Запрос всех форм
//                 const formsResponse = await fetch('/api/forms');
//                 if (!formsResponse.ok) {
//                     throw new Error(`Ошибка при получении форм: ${formsResponse.status}`);
//                 }
//                 const formsData = await formsResponse.json();

//                 // Соединяем подстанции с их последними формами
//                 const enrichedSubstations = substationsData.map((substation) => {
//                     // Отфильтровать формы для текущей подстанции
//                     const relatedForms = formsData
//                         .filter((form) => form.formsubstationId === substation.id && form.type === "substation");

//                     // Найти последнюю форму по дате (или вернуть null, если нет форм)
//                     const lastForm = relatedForms.length > 0
//                         ? relatedForms.reduce((latest, current) => {
//                             return new Date(latest.completionDate) > new Date(current.completionDate) ? latest : current;
//                         })
//                         : null;

//                     return {
//                         ...substation,
//                         lastForm,
//                     };
//                 });

//                 setSubstations(enrichedSubstations);
//             } catch (error) {
//                 console.error('Ошибка загрузки данных:', error);
//             }
//         }

//         fetchData();
//     }, []);

//     return (
//         <Layout>
//             <div className="substations">
//                 <div className="container">
//                     <div className="substations-all">
//                         <p className="substations-all__title">Все подстанции</p>
//                         <ul className="substations-all__list list">
//                             {substations.map((substation) => (
//                                 <li key={substation.id} className="list-item">
//                                     <Link className="list-item__link d-flex" to={`/indicators/substations/${substation.slug}`}>
//                                         <p className="list-item__name">
//                                             {substation.name}
//                                         </p>
//                                         {substation.lastForm ? (
//                                             <div className="list-item__report d-flex">
//                                                 {/* <p className="report-date">
//                                                     Дата: {new Date(substation.lastForm.completionDate).toLocaleString()} 
//                                                 </p> */}
//                                                 <p className="report-description">
//                                                     Отчет: {substation.lastForm.description}
//                                                 </p>
//                                             </div>
//                                         ) : (
//                                             <p className="no-report">Нет отчётов</p>
//                                         )}
//                                     </Link>
//                                 </li>
//                             ))}
//                         </ul>
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     )
// }



// export default Substations;

import React from "react";
import EntitiesList from "../components/entitiesList/EntitiesList";

const SubstationsPage = () => {
    return (
        <EntitiesList 
            entityType="substation" 
            apiEndpoint="/api/substation" 
            reportType="formsubstationId" 
        />
    );
};

export default SubstationsPage;
